/** The text styles of the personalised quote page and its upsell modal. */
export type TypographyRole =
  | 'pageTitle'
  | 'lead'
  | 'label'
  | 'cardTitle'
  | 'body'
  | 'bodyStrong'
  | 'bodyLinkStrong'
  | 'promo'
  | 'price'
  | 'modalTitle'
  | 'button';

export type Typography = Record<TypographyRole, string>;

export const defaultTypography: Typography = {
  pageTitle: 'text-h1',
  lead: 'text-body-xlarge',
  label: 'text-body-large-strong',
  cardTitle: 'text-h4',
  body: 'text-body text-[16px]/[20px] tablet:text-body',
  bodyStrong: 'text-body-strong text-[16px]/[20px] tablet:text-body-strong',
  bodyLinkStrong: 'text-body-link-strong text-[16px]/[20px] tablet:text-body-link-strong',
  promo: 'text-h4',
  price: 'text-h3',
  modalTitle: 'text-h2 text-[20px]/[24px] tablet:text-[30px]/[36px]',
  button: '[&_button]:text-body-large-strong',
};

export const typographyOverridesByBrand: Record<string, Partial<Typography>> = {
  WHIRL: {
    pageTitle: 'text-h1 font-medium',
    lead: 'text-body-3xlarge tablet:text-body-xlarge',
    label: 'text-h3 font-bold tablet:text-body-large-strong',
    cardTitle: 'text-h2 font-medium tablet:text-h4 tablet:font-medium',
    promo: 'text-h3 font-medium tablet:text-h4 tablet:font-medium',
    price: 'text-h1 font-medium tablet:text-h3 tablet:font-medium',
    button: '[&_button]:text-h3 [&_button]:font-bold tablet:[&_button]:text-body-large-strong',
  },
  KHAID: {
    pageTitle: 'text-h4 text-[24px]/[26px] tablet:text-h2',
    lead: 'text-body-large',
    price: 'text-h4',
    cardTitle: 'text-h5',
    promo: 'text-h5',
  },
  MYTAG: {
    pageTitle: 'text-h1 text-[28px]/[28px] tablet:text-[40px]/[44px]',
    lead: 'text-body-xlarge text-[18px]/[27px]',
    cardTitle: 'text-h4 text-[22px]/[26px]',
    promo: 'text-body text-[18px]/[26px] font-bold tablet:text-[20px]/[26px]',
    price: 'text-body text-[24px]/[29px] font-bold',
    button: '[&_button]:text-[18px]/[22px]',
  },
  AMANA: {
    pageTitle: 'text-h3 font-semibold uppercase',
    lead: 'text-body-large',
    cardTitle: 'text-body text-[20px]/[24px] font-medium',
    promo: 'text-h6 text-[18px]/[22px] normal-case tablet:text-h6',
    price: 'text-headline font-semibold text-[24px]',
    button: '[&_button]:text-[18px]/[22px]',
  },
  JNAIR: {
    pageTitle: 'text-h1 tablet:text-[32px]/[38px]',
    lead: 'text-body-large',
    promo: 'text-body text-[18.01px]/[24.02px] font-bold tablet:text-[20.01px]/[24.02px]',
    price: 'text-body text-[24.01px]/[24.02px] font-bold',
  },
};

export const getTypography = (brandCode?: string): Typography => ({
  ...defaultTypography,
  ...(brandCode ? typographyOverridesByBrand[brandCode] : undefined),
});
